// extracted by mini-css-extract-plugin
export default {"card1":"Home_card1__9pzh6","smallCard1":"Home_smallCard1__j6+it","smallCard2":"Home_smallCard2__jcYum","smallCard3":"Home_smallCard3__EP5LJ","smallCard4":"Home_smallCard4__303SJ"};